(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["as-seen-on"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
// Código para carregar o script jQuery
var jqueryScript = document.createElement('script');
jqueryScript.src = "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.1/jquery.min.js";
document.body.appendChild(jqueryScript);

// Adiando o carregamento do CSS do Swiper
var swiperCSS = document.createElement('link');
swiperCSS.rel = "stylesheet";
swiperCSS.href = "https://cdnjs.cloudflare.com/ajax/libs/Swiper/8.1.4/swiper-bundle.css";
swiperCSS.onload = function() {
    // Código a ser executado após o carregamento do CSS do Swiper
    var swiperScript = document.createElement('script');
    swiperScript.src = "https://cdnjs.cloudflare.com/ajax/libs/Swiper/8.1.4/swiper-bundle.min.js";
    swiperScript.onload = function() {
        // Código a ser executado após o carregamento do Swiper
        $( document ).ready(function() {
            var swiper = new Swiper(".marqueeSwiper", {
                slidesPerView: "auto",
                spaceBetween: 0,
                loop: true,
                loopAdditionalSlides: 2,
                speed: 4000,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false,
                },
                observer: true,
                observeParents: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
            });
            $(window).on("resize scroll",function(){
                swiper.update();
            });
        });
    };
    document.body.appendChild(swiperScript);
};
document.head.appendChild(swiperCSS);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // menu mobile
  const hasChildElements = document.querySelectorAll('.mobile__has-child');

  hasChildElements.forEach((element) => {
      element.addEventListener('click', (event) => {
          event.preventDefault();
  
          const subMenuList = element.querySelector('.mobile__sub-menu-list');
  
          if (event.target.classList.contains('mobile__menu-item__link')) {
              subMenuList.classList.toggle('active');
          }
  
          document.addEventListener('click', (e) => {
              if (!subMenuList.contains(e.target) && e.target !== element.querySelector('a')) {
                  subMenuList.classList.remove('active');
              }
          });
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-carousel"] && !window.DesignMode) return;
  try {
    
const carousel = document.querySelector('#logo-carousel');
let currentIndex = 0;

function loadLogos() {
    // Lista de URLs base64 para logotipos fictícios
    const logoUrls = [
        'https://cdn.shopify.com/s/files/1/0771/4327/7874/files/PR-Agency-Company-7.webp?v=1695060004',
        'https://cdn.shopify.com/s/files/1/0771/4327/7874/files/PR-Agency-Company-6.webp?v=1695059996',
        'https://cdn.shopify.com/s/files/1/0771/4327/7874/files/PR-Agency-Company-5.webp?v=1695059986',
        'https://cdn.shopify.com/s/files/1/0771/4327/7874/files/PR-Agency-Company-4.webp?v=1695059978',
        'https://cdn.shopify.com/s/files/1/0771/4327/7874/files/PR-Agency-Company-3.webp?v=1695059969',
        'https://cdn.shopify.com/s/files/1/0771/4327/7874/files/PR-Agency-Company-3.webp?v=1695059969',
        'https://cdn.shopify.com/s/files/1/0771/4327/7874/files/PR-Agency-Company-2.webp?v=1695059960',
        'https://cdn.shopify.com/s/files/1/0771/4327/7874/files/PR-Agency-Company-1.webp?v=1695059950'
    ];

    logoUrls.forEach((logoUrl) => {
        const logo = document.createElement('img');
        logo.src = logoUrl;
        carousel.appendChild(logo);
    });

    // Clone os logotipos e adicione-os no final do carrossel
    const logos = carousel.querySelectorAll('img');
    logos.forEach((logo, index) => {
        if (index < 5) {
            const clone = logo.cloneNode(true);
            carousel.appendChild(clone);
        }
    });
}

loadLogos();

function moveLeft() {
    currentIndex++;
    if (currentIndex >= carousel.children.length / 2) {
        currentIndex = 0;
    }
    updateCarousel();
}

function updateCarousel() {
    const translateX = -currentIndex * (120 + 20); // 120px é a largura de cada logotipo, 20px é o espaçamento
    carousel.style.transition = 'transform 0.5s ease'; // Adicionando uma transição suave
    carousel.style.transform = `translateX(${translateX}px)`;

    // Quando a transição terminar, remova a transição
    setTimeout(() => {
        carousel.style.transition = 'none';
    }, 500); // 500ms é o tempo da transição, ajuste conforme necessário
}

setInterval(moveLeft, 3000); // Move para o próximo logotipo a cada 3 segundos

// Inicia o carrossel com o primeiro logotipo
updateCarousel();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-tiktok"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
    const reviewsVideos = document.querySelectorAll('.review')

    reviewsVideos.forEach((review) => {
        review.addEventListener('click', () => {
            
            if (review.classList.contains('already-reproduced')) {
                return
            }
          
            review.querySelector('video').play()
            review.querySelector('.review__cover').classList.add('hide-cover')
            review.classList.add('already-reproduced')
        })
    })
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-reviews"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const closeReviewModal = document.querySelector(".review-modal__video-close");
  const reviewModal = document.querySelector(".review-modal");
  const reviewModalVideo = document.querySelector(".review-modal__video iframe");
  const showReviewModal = document.querySelectorAll(
    ".reviews-section__review-video__button"
  );
  
  showReviewModal.forEach((review) => {
    review.addEventListener("click", function (e) {
      reviewModal.classList.add("visible");
  
      let currentReview = e.target;
      let currentReivewVideoUrl = currentReview.getAttribute("data-modal-video");
      reviewModalVideo.src = currentReivewVideoUrl;
    });
  });
  
  closeReviewModal.addEventListener("click", function () {
    reviewModal.classList.remove("visible");
    reviewModalVideo.src = "";
  });
});

  } catch(e) { console.error(e); }
})();
})();
